/// <reference path="../../../../typings/index.d.ts" />
module Meevo.Plugins.ResourceCategories {
    angular.module("meevo.plugins.resourceCategories", []);
}